import { useCallback, useContext, useRef, useState } from "react";
import { ShepherdTourContext } from "../lib/shepherd";
import { isMobile } from "react-device-detect";

export const useShepherd = () => {
    const shepherd = useContext(ShepherdTourContext);

    const [idWhenPaused, setIdWhenPaused] = useState<string | null>(null);

    const onFocus = useCallback(() => {
      if (isMobile && shepherd.isActive()) {
        setIdWhenPaused(shepherd.getCurrentStep()?.id || '');
        shepherd.hide();
      }
    }, [shepherd]);

    const onBlur = useCallback(() => {
      if (shepherd.isActive() && idWhenPaused) {
        shepherd.show(idWhenPaused);
        setIdWhenPaused(null);
      }
    }, [shepherd, idWhenPaused]);



    return {
      shepherd,
      onFocus,
      onBlur
    }
  
}